import { SHTypography } from "@components/design-systems";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { ManagedAccountFieldTypeValue } from "@models/managed-accounts/enums/fieldTypeValue";
import { memo } from "react";

interface DateTimeCellProps {
  analysisData?: MAAnalysisDataDTO;
}

export const DateTimeCell = memo(({ analysisData }: DateTimeCellProps) => {
  if (analysisData?.value === ManagedAccountFieldTypeValue.Multiple) {
    return (
      <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
        Multiple
      </SHTypography>
    );
  }

  return (
    <SHTypography variant="body3" colorVariant="third" lineHeight="120%">
      {analysisData?.value}
    </SHTypography>
  );
});
